var map = {
	"./az/index.js": [
		3325,
		1626
	],
	"./bn/index.js": [
		6626,
		4629
	],
	"./en/index.js": [
		94613,
		3938
	],
	"./es/index.js": [
		31354,
		6889
	],
	"./hi/index.js": [
		74641,
		7426
	],
	"./kk/index.js": [
		13908,
		9367
	],
	"./ky/index.js": [
		18854,
		6085
	],
	"./ru/index.js": [
		33455,
		9332
	],
	"./uk/index.js": [
		80594,
		2289
	],
	"./uz/index.js": [
		1817,
		3030
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 69743;
module.exports = webpackAsyncContext;